import { useCallback, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import {
    buildOpeningsClosingsParams,
    OpeningsClosingsQuery,
} from '@apiHooks/openingsClosingsParams.helpers';

const REQUEST_TYPE: keyof typeof apiConfig = 'get restaurant openings closings export';

export interface RestaurantOpeningsClosingsExport {
    requestExport: () => Promise<void>;
    isExporting: boolean;
}

export const useRestaurantOpeningsClosingsExport = (
    query: OpeningsClosingsQuery,
): RestaurantOpeningsClosingsExport => {
    const [isExporting, setIsExporting] = useState(false);
    const isExportingRef = useRef(false);

    const requestExport = useCallback(async () => {
        if (isExportingRef.current) return;

        isExportingRef.current = true;
        setIsExporting(true);
        try {
            await http.downloadFileXHR('GET', REQUEST_TYPE, buildOpeningsClosingsParams(query));
        } catch {
            toast.error('Export failed. Please try again.');
        } finally {
            isExportingRef.current = false;
            setIsExporting(false);
        }
    }, [query]);

    return { requestExport, isExporting };
};
